import { Component, ViewChild } from "@angular/core";
import { DxDataGridComponent } from "devextreme-angular";
import { NotificationService } from "../common/component/notification/notification.service";
import { UserRole, UserRoleService } from "./user-role.service";
import 'jspdf-autotable';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';

@Component({
    selector: 'activity-process-feedstock1',
    templateUrl: './user-role.component.html',
    styleUrls: ['./user-role.component.scss']
})

export class UserRoleComponent {

    @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
    userRoleList: UserRole[];
    isLoadPanelVisible: boolean = false

    readonly allowedPageSizes = [50, 100, 200];

    constructor(private notificationService: NotificationService, private userRoleService: UserRoleService) {
        this.getUserRoles();
    }

    getUserRoles() {
        this.isLoadPanelVisible = true;
        this.userRoleService.getUserRoles().subscribe({
            next: data => {
                this.userRoleList = data;
                this.isLoadPanelVisible = false;
            }, error: (error) => {
                this.notificationService.alert("error", "Error while fetching User Roles", error);
                this.isLoadPanelVisible = false;
            }
        });
    }

    exportExcel(e) {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
            component: this.dataGrid.instance,
            worksheet: worksheet
        }).then(function () {
            workbook.xlsx.writeBuffer()
                .then(function (buffer: BlobPart) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'User-Roles.xlsx');
                });
        });
        e.cancel = true;
    }

    goToIam() {
        window.open('https://iam.airproducts.com', '_blank');
    }

    refreshGrid() {
        this.userRoleList = null;
        this.getUserRoles();
    }
}
